import scrollama from 'scrollama';
import _throttle from 'lodash.throttle';

const scrollyEls = document.querySelectorAll('.c-scrolly--desktop');

if (scrollyEls) {
  const readjust = scrollyEl => {
    const scrollyGradient = scrollyEl.querySelector('.c-scrolly__gradient');
    const scrollyElBox = scrollyEl.getBoundingClientRect();

    scrollyGradient.style.right = `${(window.outerWidth - scrollyElBox.width) /
      2}px`;
  };

  scrollyEls.forEach(scrollyEl => {
    const scrollerSteps = scrollama();
    const scrollerParent = scrollama();

    readjust(scrollyEl);

    const scrollyParents = scrollyEl.querySelectorAll('.c-scrolly__parent');

    scrollyParents.forEach(parentEl => {
      if (parentEl.localName === 'button') {
        parentEl.addEventListener('click', () => {
          const { stepParent } = parentEl.dataset;
          const firstChild = scrollyEl.querySelector(
            `.c-scrolly__step[data-step=${stepParent}]`,
          );
          const scrollyContentEl = scrollyEl.querySelector(
            '.c-scrolly__content',
          );
          const scrollyContentPaddingtop = getComputedStyle(
            scrollyContentEl,
          ).paddingTop.replace('px', '');

          window.scrollBy({
            left: 0,
            top:
              firstChild.getBoundingClientRect().y - scrollyContentPaddingtop,
            behavior: 'smooth',
          });
        });
      }
    });

    // Control the gradient element which gets displayed on top of the scrolly-telling children
    scrollerParent
      .setup({
        step: scrollyEl,
      })
      .onStepEnter(() => {
        const gradient = scrollyEl.querySelector('.c-scrolly__gradient');
        gradient.classList.add('is-active');
      })
      .onStepExit(() => {
        const gradient = scrollyEl.querySelector('.c-scrolly__gradient');
        gradient.classList.remove('is-active');
      });

    // The actual scrolly telling elements
    scrollerSteps
      .setup({
        step: scrollyEl.querySelectorAll('.c-scrolly__step'),
      })
      .onStepEnter(res => {
        const { element } = res;
        const { step } = element.dataset;
        const parentEl = document.querySelectorAll(`.c-scrolly__parent`);

        parentEl.forEach(el => {
          const { stepParent } = el.dataset;

          if (step === stepParent) el.classList.add('is-active');
        });
      })
      .onStepExit(res => {
        const { element } = res;
        const { step } = element.dataset;
        const parentEl = document.querySelectorAll(`.c-scrolly__parent`);

        parentEl.forEach(el => {
          const { stepParent } = el.dataset;

          if (step !== stepParent) el.classList.remove('is-active');
        });
      });

    // Readjust on window resize
    window.addEventListener(
      'resize',
      _throttle(() => readjust(scrollyEl), 500),
    );
  });
}



// WEBPACK FOOTER //
// ./src/scripts/modules/scrollyTelling.js